// LandlordDashboard.jsx
import React from 'react';
import LandLoadPropertyCard from './LandLoadPropertyCard';
import LandLordTable from '../Table/LandLordTable';
import LandLordTestSummary from '../../pages/LandLord/LandLordTestSummary';

const LandlordDashboard = ({ properties, showTable, selectedProperty, onViewUnits, onBackToCards }) => {
  console.log("property", properties);
  return (
    <>
      {showTable ? (
        <div>
          <LandLordTestSummary property={selectedProperty} />
        </div>
      ) : (
        properties.map((property, index) => (
          <div key={index} className="
            inline-block 
            align-top
            sm:w-[336px] 
            md:w-[342px] 
            lg:w-[278px] 
            mr-[87px]
            mb-4
            sm:max-w-[352px]
            md:max-w-[384px]
            lg:max-w-[320px]
            max-w-[90vw]
          ">
            <LandLoadPropertyCard
              title={property.propertyName}
              location={`${property.location[0].city}, ${property.location[0].area}`}  // Combine city and area
              occupied={property.occupied}
              vacant={property.vacant}
              totalUnits={property.totalUnits}
              expectedRent={property.rentExpected}
              rentCollected={property.totalRentCollected}
              rentCollectedThisMonth={property.currentMonthOnTimeAmount}
              onViewUnits={() => onViewUnits(property)}
            />
          </div>
        ))
      )}
    </>
  );
};

export default LandlordDashboard;
